<template>
	<div class="container teacher-container">		
		<header class="topbar fixed-top px-5 py-3 d-flex justify-content-between align-items-center" :class="{ 'scrolling': scrolling }">
			<div class="d-flex">
				<breadcrumb class="mr-5" v-if="breadcrumbTo && currentPage !== 'pages'" :to="breadcrumbTo" :useOffset="false" id="header-breadcrumb" />
				<div class="d-flex align-items-center" v-if="currentPage == 'pages'">
					<!-- <h3 class="text-uppercase condensed mb-0 mr-3">MEET-A-SIDE</h3> -->
					<emoji-code class="room-code" type="tiny-transparent"/>
				</div>		
			</div>
			<img class="logo" src="~@img/misc/logo_small.png" />
			<fullscreen-toggle-button id="fullscreen-toggle-button"/>
		</header>
		<transition :name="componentTransition">
			<component :is="currentPage" class="teacher-page"></component>
		</transition>
	</div>
</template>

<script>
    import * as extend from 'extend'

	import ConnectPage from './flow/0-connect'
    import IntroPage from './flow/1-intro'
    import SelectThemePage from './flow/2-select-theme'
    import SelectCasePage from './flow/3-select-case'
    import LobbyPage from './flow/4-lobby'
    import PageController from './flow/5-page-controller'

    import FullscreenToggleButton from '@/components/fullscreen-toggle-button'
	import EmojiCode from '@/components/emoji-code'
	import PlayerType from '@/enum/PlayerType';
    import GameClientEvent from '@/enum/GameClientEvent'
    import GamePhase from '@/enum/GamePhase'
    import GameType from '@/enum/GameType'
    import GameClientType from '@/enum/GameClientType'
    import {ConsoleLogger} from '@/console-logger'
    import {$eBus} from '@/event-bus'
    import AppConfig from '@/app-config'
    import {mapGetters} from 'vuex'

    import * as MutationTypes from '@/store/mutation-types'
    import {getTeacherUrl} from '@/utils/UrlUtil'
	import Breadcrumb from '@/components/breadcrumb'

    const pageComponents = {
		'connect': ConnectPage,
		'intro': IntroPage,
		'select-theme': SelectThemePage,
		'select-case': SelectCasePage,
		'lobby': LobbyPage,
		'pages': PageController
	}

	const components = {
		Breadcrumb,
		EmojiCode,
		FullscreenToggleButton
	}

	export default {
		components: extend(components, pageComponents),
		data() {
			return {
				componentTransition: AppConfig.componentTransition,
				currentPage: 'connect',
				logger: new ConsoleLogger('TeacherController', 'background: #00aaaa; color: white', null,
					!AppConfig.debug.teacherController),
				scrolling: false
			}
		},
		watch: {
			'$route'(to, from) {
				this.reloadCurrentPage(to)
			}
		},
		computed: {
			...mapGetters({
				breadcrumbTo: 'getBreadcrumbTo',
			}),
		},
		methods: {
			onRoomStateChanged(room) {
				let roomState = room && room.state ? room.state : {}

				if (roomState.hasOwnProperty('currentPageIndex') && roomState.currentPageIndex >= 0) {
					this.$store.commit(MutationTypes.SET_CURRENT_PAGE_INDEX, roomState.currentPageIndex)
				}

				if (roomState.hasOwnProperty('pagePhase')) {
					this.$store.commit(MutationTypes.SET_CURRENT_PAGE_PHASE, roomState.pagePhase)
				}

			      if (roomState.hasOwnProperty('playerVotes')) {
			        roomState.playerVotes.forEach((value, key) => {
			          let votes = [];

			          value.votes.forEach((_value, _key) => {
			            votes.push(_value);
			          });

			          console.log('playerVotesEach', key, votes);
			        });
			      }
			},
			onPhaseChanged(newPhase) {
				this.$store.commit(MutationTypes.SET_CURRENT_GAME_PHASE, newPhase)

				if (newPhase === GamePhase.Lobby) {
					this.logger.logMessage(`Going to Lobby as the GameClient said that's the current phase`)
					this.$store.dispatch({type: 'reset'})
					this.$router.push(getTeacherUrl('lobby'))
				} else if (newPhase === GamePhase.Pages) {
					this.postSession();
					this.logger.logMessage(`Going to Pages as the GameClient said that's the current phase`)
					this.$router.push(getTeacherUrl('pages'))
				} else if (newPhase === GamePhase.End) {
					this.$store.dispatch({type: 'reset'})
					this.$router.push(getTeacherUrl('lobby'))
				}
			},
			postSession() {
				const caseId = this.$store.state.currentCase.id;
				const language = this.$store.state.language;
				const data = {};
				const session = {
					caseId: caseId,
					language: language,
					data: data
				}
				this.$apiClient.postSession(session, (data) => {
					this.$store.commit(MutationTypes.SET_SESSION_ID, data.id);
				}, () => {});
			},
			reloadCurrentPage(route) {
				let currentPage = route.params.page

		      if (route.params.caseId) {
		        let caseId = parseInt(route.params.caseId, 10);

		        if (caseId) {
		          //this.$store.commit(MutationTypes.SET_CLASS_CASE_ID, caseId);
		        }
		      }

				if (!currentPage || !components.hasOwnProperty(currentPage)) {
					this.logger.logMessage(`Unknown TeacherPage "${currentPage}"`)

					this.$router.push(getTeacherUrl('connect'))

					return
				}

				this.logger.logMessage(`TeacherPage changed to "${currentPage}"`)

				this.currentPage = currentPage
			},
			onScroll() {
				this.scrolling = window.scrollY > 0;
			}
		},
		mounted() {
			this.$store.commit(MutationTypes.SET_PLAYER_TYPE, PlayerType.Teacher);
			this.$store.commit(MutationTypes.SET_GAME_CLIENT_TYPE, GameClientType.Online);
			this.$store.commit(MutationTypes.SET_GAME_TYPE, GameType.ClassRoom);

			$eBus.$on('gameClient:onDisconnected', () => {
		      console.log('GAME CLIENT ON DISCONNECTED!!11!!');
		    });
		    

			$eBus.$on(GameClientEvent.RoomStateChange, this.onRoomStateChanged)
			$eBus.$on(GameClientEvent.PhaseChanged, this.onPhaseChanged)

			document.addEventListener('scroll', this.onScroll);
			
			this.reloadCurrentPage(this.$router.currentRoute)
		},
		beforeDestroy() {
			$eBus.$off(GameClientEvent.RoomStateChange, this.onRoomStateChanged)
			$eBus.$off(GameClientEvent.PhaseChanged, this.onPhaseChanged)
			document.removeEventListener('scroll', this.onScroll);
		}
	}
</script>
<style lang="less" scoped>
	@import "~@less/variables.less";

	.teacher-container {
		position: relative;
	}

	.topbar {
		transition: background-color 0.3s ease-out;

		&.scrolling {
			background-color: rgba(0, 0, 0, 0.9);
		}

		.logo {
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
		}
		
		& > * {
			max-height: 50px;
		}
	}

	.teacher-page {
		position: absolute;
		top: 50px;
		left: 0;
		width: 100%;
		padding-top: 50px;
	}
</style>